import { render, staticRenderFns } from "./WidgetGetSponsorLicenceDialog.vue?vue&type=template&id=38a55502&scoped=true&lang=pug"
import script from "./WidgetGetSponsorLicenceDialog.vue?vue&type=script&lang=ts"
export * from "./WidgetGetSponsorLicenceDialog.vue?vue&type=script&lang=ts"
import style0 from "./WidgetGetSponsorLicenceDialog.vue?vue&type=style&index=0&id=38a55502&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a55502",
  null
  
)

/* custom blocks */
import block0 from "./WidgetGetSponsorLicenceDialog.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FCompliance%2FWidgets%2FWidgetGetSponsorLicence%2FWidgetGetSponsorLicenceDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports